module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-KX5600.d86c6b05.png";